module.exports = __webpack_public_path__ + "5f0743a77a0a593ce9def479b579f87b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-17.png
// module id = 3278
// module chunks = 0